import colors from '_containers/Theme/intheblack/colors';

export default {
  background: colors.darkTheme.background.tint1,
  color: colors.all.neutralWhite,
};
